import { render, staticRenderFns } from "./CensusForm.vue?vue&type=template&id=1c4d5a20&"
import script from "./CensusForm.vue?vue&type=script&lang=js&"
export * from "./CensusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports